export default {
  'documents': 'Documents',
  'documentSearch': 'Recherche de Document',
};